import { bus } from '../plugins/event-bus'
import { lockBodyScroll, unlockBodyScroll } from './bodyScrollLock'

/* Estesoft.App `assets/js/utils/modalService.js`'in Vega/BS4 uyarlaması (bayt-aynı kopya değildir).
   show/close clientapp ile aynı; ek olarak üç modal ailesinin (ModalHost, BaseModal, route modal)
   paylaştığı gövde kilidi ve Esc yığını burada durur. */

// Kendi başlığını ve ayağını taşıyan geniş form penceresi (hızlı randevu): kabuk yalnız perdeyi ve kutuyu verir,
// içerik kaydırma almaz; açılır listeler pencerenin içinde kesilmez, uzun içerikte sayfa kayar.
export const FAST_APPOINTMENT_MODAL = { header: { show: false }, footer: { show: false }, size: 'modal-lg', closeOnEsc: true, clickToClose: true };

export default {
    show(component, props = {}, options = {}) {
        bus.$emit('show-modal', { component, props, options });
    },
    close(params = {}) {
        bus.$emit('close-modal', params);
    },
};

/* Gövde: bodyScrollLock.js clientapp ile bayt-aynı kalır (est-modal-open). BS4'te `.modal` yalnız
   `body.modal-open` altında kayar (`overflow-y: auto`), bu yüzden sınıf burada eklenir. Kaydırma
   çubuğu kaybolunca sayfa kaymasın diye bootstrap-vue modal yöneticisi gibi gövdeye sağ boşluk
   verilir. Sayaçlıdır: son modal kapanınca geri alınır. */
let modalCount = 0;
let bodyPaddingBefore = null;

export function lockModalBody() {
    lockBodyScroll();
    modalCount += 1;
    if (modalCount > 1) return;

    const body = document.body;
    const rect = body.getBoundingClientRect();
    const isBodyOverflowing = rect.left + rect.right < window.innerWidth;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (isBodyOverflowing && scrollbarWidth > 0) {
        bodyPaddingBefore = body.style.paddingRight || '';
        const current = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
        body.style.paddingRight = `${current + scrollbarWidth}px`;
    }
    body.classList.add('modal-open');
}

export function unlockModalBody() {
    unlockBodyScroll();
    modalCount = Math.max(0, modalCount - 1);
    if (modalCount > 0) return;

    const body = document.body;
    body.classList.remove('modal-open');
    if (bodyPaddingBefore !== null) {
        body.style.paddingRight = bodyPaddingBefore;
        bodyPaddingBefore = null;
    }
}

/* Üst üste açık modallarda Esc yalnız en üsttekine gider; z-index de sıraya göre verilir
   (bootstrap-vue: 1040 + sıra, dış sarmalayıcıda). */
const stack = [];

function onKeydown(event) {
    if (event.key !== 'Escape' || !stack.length) return;
    const top = stack[stack.length - 1];
    if (top.onEscape) top.onEscape(event);
}

export function pushModal(entry) {
    if (!stack.length) window.addEventListener('keydown', onKeydown);
    stack.push(entry);
    return 1040 + stack.length - 1;
}

export function removeModal(entry) {
    const index = stack.lastIndexOf(entry);
    if (index > -1) stack.splice(index, 1);
    if (!stack.length) window.removeEventListener('keydown', onKeydown);
}

export function isTopModal(entry) {
    return stack.length > 0 && stack[stack.length - 1] === entry;
}

/* Odak modalın içinde kalır (clientapp VueRouterModalComponent.handleTabKey). */
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function trapTabKey(event, container) {
    if (event.key !== 'Tab' || !container) return;

    const focusable = Array.from(container.querySelectorAll(FOCUSABLE)).filter(el => el.offsetParent !== null);
    if (!focusable.length) {
        event.preventDefault();
        return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!container.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
    }
}
